import * as THREE from "three";
import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import GUI from "lil-gui";
import { Timer } from "three/addons/misc/Timer.js";
import { initTerrain } from "./includes/terrain.js";
import { initSnow } from "./includes/snow.js";
import { initHouses } from "./includes/houses.js";
import { initGrinches } from "./includes/grinches.js";
import { initScores } from "./includes/scores.js";

/**
 * Base
 */
// Debug
const isDebugMode = window.location.hash === "#debug";
document.body.classList.toggle("debug", isDebugMode);

const gui = new GUI({ width: 340 });
if (!isDebugMode) {
  gui.hide();
}

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color("#0e1c2e");

// Loaders
const textureLoader = new THREE.TextureLoader();

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  25,
  sizes.width / sizes.height,
  0.1,
  1000
);
// camera.position.set(-8, 5, 22);
// camera.position.set(17, 3, -8);
camera.position.set(0, 30, 200);
scene.add(camera);
gui.add(
  { "reset camera": () => camera.position.set(0, 30, 200) },
  "reset camera"
);

// Experience
const experience = {
  isRunning: false,
  isDebugMode: isDebugMode,
  gui: gui,
  scene: scene,
  camera: camera,
  textureLoader: textureLoader,
  houseTest: null,
  grinches: [],
  grinchesToDisplay: [],
};

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
if (!isDebugMode) {
  controls.enabled = false;
}

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Floor
 */
initTerrain(experience);

/**
 * Snow
 */
initSnow(experience);

/**
 * Houses
 */
initHouses(experience);

/**
 * Grinches
 */
initGrinches(experience);

/**
 * Scores
 */
initScores(experience);

/**
 * Start experience
 */
const windAudio = new Audio("/sounds/wind-01.mp3");
const jingleAudio = new Audio("/sounds/jingle-bells.m4a");

experience.start = () => {
  experience.isRunning = true;
  console.log(jingleAudio);

  const audio = jingleAudio;
  audio.play();
  console.log(jingleAudio);
  audio.volume = 0.25;
  windAudio.play();
  windAudio.loop = true;
  audio.addEventListener("ended", (event) => {
    experience.end();
  });
  gui.add({ stop: () => audio.pause() }, "stop");
  gui.add({ end: () => experience.end() }, "end");
  document.querySelector(".end-btn").addEventListener("click", () => {
    experience.end();
    audio.pause();
  });
};
const startScreen = document.querySelector(".start-screen");
const startButton = document.querySelector(".start-button");
startButton.addEventListener("click", () => {
  startScreen.style.display = "none";
  experience.start();
});

/**
 * End experience
 */
experience.end = () => {
  experience.isRunning = false;
  experience.updateTotal();
  document.querySelector(".end-screen").classList.add("active");
  windAudio.pause();

  const audio = new Audio("/sounds/applause-02.mp3");
  audio.play();
  // audio.addEventListener("ended", (event) => {
  //   experience.reset();
  // });
};

/**
 * Countdown
 */
const countdownElement = document.createElement("div");
countdownElement.classList.add("countdown");
document.body.appendChild(countdownElement);

const updateCountdown = () => {
  const totalSeconds = Math.floor(jingleAudio.duration);
  const currentSeconds = Math.floor(jingleAudio.currentTime);
  const remainingSeconds = totalSeconds - currentSeconds;
  countdownElement.textContent = remainingSeconds.toString().padStart(2, "0");
};

/**
 * axes helper
 */
const axesHelper = new THREE.AxesHelper();
axesHelper.position.y = 2;
scene.add(axesHelper);

/**
 * Animate
 */
const timer = new Timer();

const tick = () => {
  // Update controls
  controls.update();

  if (!jingleAudio.paused) {
    updateCountdown();
  }

  if (experience.isDebugMode) {
    experience.houseTest.position.x = experience.debugHouse.posX;
    experience.houseTest.position.y = experience.debugHouse.posY;
    experience.houseTest.position.z = experience.debugHouse.posZ;
    experience.houseTest.rotation.y = experience.debugHouse.rotY || 0;
  }

  timer.update();
  const elapsedTime = timer.getElapsed();
  // const delta = timer.getDelta();
  // house.rotation.y = elapsedTime;
  experience.animateSnow(elapsedTime);

  if (experience.isRunning) {
    experience.animateRandomGrinch(elapsedTime * 1000);
  }

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
